<template>
  <!-- =========== Hero Section Start =========== -->
  <LandingShowcase> </LandingShowcase>
  <!-- =========== Hero Section End =========== -->

  <!-- =========== feature Section Start =========== -->
  <LandingFeatures> </LandingFeatures>
  <!-- =========== feature Section end =========== -->

  <!-- =========== clients Section Start =========== -->
  <LandingClients> </LandingClients>
  <!-- =========== clients Section end =========== -->

  <!-- =========== testimonial Section Start =========== -->
  <LandingTestimonial> </LandingTestimonial>
  <!-- =========== testimonial Section end =========== -->

  <!-- =========== pricing Section Start =========== -->
  <LandingPricing> </LandingPricing>
  <!-- =========== pricing Section end =========== -->

  <blog-boxes class="container mx-auto px-4 max-w-4xl">
    <single-blog-box
      v-for="(blog, index) in homeBlogStore.blogs"
      :key="index"
      :blog="blog"
    />
  </blog-boxes>

  <!-- =========== faq Section start =========== -->
  <LandingFaq> </LandingFaq>
  <!-- =========== faq Section end =========== -->
</template>

<script setup>
import LandingShowcase from "../components/LandingLayout/template-parts/LandingShowcase.vue";
import LandingFeatures from "../components/LandingLayout/template-parts/LandingFeatures.vue";
import LandingClients from "../components/LandingLayout/template-parts/LandingClients.vue";
import LandingTestimonial from "../components/LandingLayout/template-parts/LandingTestimonial.vue";
import LandingPricing from "../components/LandingLayout/template-parts/LandingPricing.vue";
import LandingFaq from "../components/LandingLayout/template-parts/LandingFaq.vue";
import BlogBoxes from "@/components/LandingLayout/landing-compoments/BlogBoxes.vue";

import SingleBlogBox from "@/components/LandingLayout/landing-compoments/SingleBlogBox.vue";

import { onMounted } from "vue";

import { useShowcaseStore } from "@/stores/showcaseStore";
import { useFeatureStore } from "@/stores/featureStore";
import { usePartnerStore } from "@/stores/partnerStore";
import { usePackageStore } from "@/stores/packageStore";
import { useFaqsStore } from "@/stores/faqsStore";
import { useHomeBlogStore } from "@/stores/homeBlogStore";

const showcaseStore = useShowcaseStore();
const featureStore = useFeatureStore();
const partnerStore = usePartnerStore();
const packageStore = usePackageStore();
const faqsStore = useFaqsStore();
const homeBlogStore = useHomeBlogStore();

onMounted(() => {
  if (showcaseStore.sliders.length === 0) showcaseStore.fetchMainShowcase();
  if (featureStore.features.length === 0) featureStore.fetchFeatures();
  if (partnerStore.partners.length === 0) partnerStore.fetchPartners();
  if (packageStore.packages.length === 0) packageStore.fetchPackages();
  if (faqsStore.faqs.length === 0) faqsStore.fetchFaqs();
  if (homeBlogStore.blogs.length === 0) homeBlogStore.fetchBlogs();
});
</script>
